import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { login, refreshToken } from '@api/auth';
import { IAuthResponse } from '@interfaces/auth';

export const handleLogin = createAsyncThunk<AxiosResponse<IAuthResponse>, string>('login', login);

export const handleRefreshToken = createAsyncThunk<AxiosResponse<IAuthResponse>, void>(
  'refreshToken',
  refreshToken,
);
